<template>
  <section class="s-form">
    <form @submit.prevent="submit">
      <label>
        <input
          class="form-field"
          type="text"
          placeholder="Nome e Cognome"
          autocomplete="off"
          name="firstname"
          v-model="join.name"
          required
          data-cta
        />
      </label>
      <label>
        <input
          class="form-field"
          type="text"
          placeholder="Azienda"
          autocomplete="off"
          name="company"
          v-model="join.company"
          required
          data-cta
        />
      </label>
      <label>
        <input
          class="form-field"
          type="email"
          placeholder="Email"
          autocomplete="off"
          name="email"
          v-model="join.email"
          required
          data-cta
        />
      </label>
      <label>
        <input
          class="form-field"
          type="phone"
          placeholder="Telefono"
          autocomplete="off"
          name="phone"
          v-model="join.phone"
          required
          data-cta
        />
      </label>
      <label>
        <textarea
          class="form-field"
          placeholder="Messagio"
          autocomplete="off"
          name="message"
          v-model="join.message"
          required
          data-cta
        ></textarea>
      </label>
      <label>
        <span v-html="lang === 'it' ? 'Accetta la nostra ' : 'Accept our '"></span>
        <a target="_blank" :href="lang === 'en' ? 'https://www.iubenda.com/privacy-policy/98087786' : 'https://www.iubenda.com/privacy-policy/98087786'" data-cta>
          <u>Privacy</u>
        </a>
        <span class="form-checkbox" data-cta></span>
      </label>
      <label>
        <button class="form-submit" type="submit" data-cta>Invia Richiesta</button>
      </label>
      <p class="form-notification"></p>
    </form>
  </section>
</template>

<script>
import axios from 'axios';
import { app } from '@/utils/store';

import Form from './form';

let form;

export default {
  mounted() {
    form = new Form();
    form.init();
  },
  data() {
    return {
      path: '/',
      lang: app.languages,
      join: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: '',
      },
    };
  },
  methods: {
    submit(evt) {
      evt.preventDefault();
      if (
        document
          .querySelector('.form-checkbox')
          .classList.contains('is-checked')
      ) {
        axios
          .post('https://us-central1-adtelier.cloudfunctions.net/api/sendMail', {
            name: this.join.name,
            company: this.join.company,
            email: this.join.email,
            phone: this.join.phone,
            message: this.join.message,
          })
          .then((response) => {
            console.log('success', response.data.message);
            document.querySelector('form').reset();
            document.querySelector('.form-notification').innerHTML = 'Thank you for your message.';
          })
          .catch((error) => {
            console.log(error.response);
            document.querySelector('form').reset();
            document.querySelector('.form-notification').innerHTML = 'Something went wrong, please try again';
          });
      } else {
        document.querySelector('.form-notification').innerHTML = 'Please accept our Privacy Terms';
      }
    },
  },
};
</script>
